import { render, staticRenderFns } from "./casesDetail.vue?vue&type=template&id=bc1f995c&scoped=true"
import script from "./casesDetail.vue?vue&type=script&lang=js"
export * from "./casesDetail.vue?vue&type=script&lang=js"
import style0 from "./casesDetail.vue?vue&type=style&index=0&id=bc1f995c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1f995c",
  null
  
)

export default component.exports